import { render } from "./ThRules.vue?vue&type=template&id=f5e6f5da&scoped=true"
import script from "./ThRules.vue?vue&type=script&scoped=true&lang=js"
export * from "./ThRules.vue?vue&type=script&scoped=true&lang=js"

import "./ThRules.vue?vue&type=style&index=0&id=f5e6f5da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f5e6f5da"

export default script